import type {BioIconProps} from './common-types'

function Icon({...attributes}: BioIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...attributes}>
      <path
        // stroke="#363636"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 12h14M12 5l7 7-7 7"
      ></path>
    </svg>
  )
}

export const IconArrowRight = Icon
